export default __webpack_public_path__ + "static/media/button_banner.6e707d18.png";